import { createSlice } from "@reduxjs/toolkit";

interface UIState {
  isSidebarOpen: boolean;
  formSidebarOpen: boolean;
  theme: "light" | "dark";
  isLoading: boolean;
  notifications: Array<{
    id: string;
    type: "success" | "error" | "info" | "warning";
    message: string;
    timestamp: number;
  }>;
  editingHolder: any | null;
  editingRequisite: any | null;
}

const initialState: UIState = {
  isSidebarOpen: window.innerWidth > 768,
  formSidebarOpen: false,
  theme: "light",
  isLoading: false,
  notifications: [],
  editingHolder: null,
  editingRequisite: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.isSidebarOpen = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now().toString(),
        ...action.payload,
        timestamp: Date.now(),
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    openFormSidebar: (state) => {
      state.formSidebarOpen = true;
    },
    closeFormSidebar: (state) => {
      state.formSidebarOpen = false;
      state.editingHolder = null;
      state.editingRequisite = null;
    },
    setEditingHolder: (state, action) => {
      state.editingHolder = action.payload;
      state.editingRequisite = null;
      state.formSidebarOpen = true;
    },
    setEditingRequisite: (state, action) => {
      state.editingRequisite = action.payload;
      state.editingHolder = null;
      state.formSidebarOpen = true;
    },
    clearEditingData: (state) => {
      state.editingHolder = null;
      state.editingRequisite = null;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setTheme,
  setLoading,
  addNotification,
  removeNotification,
  clearNotifications,
  openFormSidebar,
  closeFormSidebar,
  setEditingHolder,
  setEditingRequisite,
  clearEditingData,
} = uiSlice.actions;

export default uiSlice.reducer;
